/* eslint-disable comma-dangle */
import { XMLBuilder } from 'fast-xml-parser';
import { CONFIGURATION_TYPE } from 'utils/constant';

const PAYMENT_MODE = {
	de: '30 Tage netto',
	en: '30 Tage netto',
	fr: '30 jours net',
	it: '30 Tage netto',
};

const ROAD_TAX = {
	de: 'LSVA',
	en: 'LSVA',
	fr: 'RPLP',
	it: 'LSVA',
};

function buildCdrAddress() {
	return {
		TYP: 'FIRMA',
		NUMMER: 1,
		KZ_BESTSTAFFEL: 0,
		ANSCHRIFT: {
			NAME1: 'CDR Glas AG',
			STRASSE: 'Oberwilstrasse 3',
			PLZ: '3253',
			ORT: 'Schnottwil',
			LAND: 'CH',
		},
		KONTAKT: {
			TLF: '+41 / 32 312 03 00',
			MAIL: 'info@cdr.ch',
		},
	};
}

function freightMode(conf, lang) {
	const mode = {
		mono: {
			de: 'CDR (Lieferwagen 3.5 t)',
			en: 'CDR (Lieferwagen 3.5 t)',
			fr: 'CDR (Camionnette 3.5 t)',
			it: 'CDR (Lieferwagen 3.5 t)',
		},
		iso: {
			de: 'Glas Trösch Bützberg (LKW)',
			en: 'Glas Trösch Bützberg (LKW)',
			fr: 'GT Bulle (Camion)',
			it: 'Glas Trösch Bützberg (LKW)',
		},
	};
	const fm = conf.glassTypes.some(gt => gt.verasIds?.productType === 'ISO') ? 'iso' : 'mono';
	return mode[fm][lang];
}

function verasFormatLen(len) {
	return Number(len).toFixed(4);
}

function verasFormatPrice(p) {
	return Number(p).toFixed(2);
}

function buildAddress(conf) {
	return {
		TYP: 'HAUPTADRESSE',
		NUMMER: conf.userData.client_company_reference || null,
		KZ_BESTSTAFFEL: 0,
		ANSCHRIFT: {
			NAME1: conf.userData.client_company_name,
			STRASSE: conf.userData.client_company_street,
			PLZ: conf.userData.client_company_zip,
			ORT: conf.userData.client_company_city,
			LAND: 'CH',
		},
		KONTAKT: {
			TLF: conf.userData.client_company_phone,
			MAIL: conf.userData.client_email,
			ANSPRECHPARTNER: '',
		},
	};
}

function buildPositions(conf) {
	const out = [];

	conf.glassTypes.forEach((gt, gtIdx) => {
		gt.positions.forEach((p, posIdx) => {
			const posTotal = conf.totals.totalGlassSizes[gtIdx][posIdx];
			const { verasIds } = gt;
			const elements =
				verasIds.productType === 'ISO'
					? [
							...(gt.structure === '2-glazed' || gt.structure === '3-glazed'
								? [
										{
											PRODUKT: {
												TYP: verasIds.outerGlassVerasType,
												NUMMER: verasIds.outerGlassVerasId,
												BEZEICHNUNG: '',
												INFOS: null,
											},
										},
										{
											PRODUKT: {
												TYP: 'ABSTANDHALTER',
												NUMMER: verasIds.spacerId,
												BEZEICHNUNG: '',
												INFOS: null,
											},
										},
										{
											PRODUKT: {
												TYP: 'GASFUELLUNGEN',
												NUMMER: verasIds.gasId,
												BEZEICHNUNG: '',
												INFOS: null,
											},
										},
									]
								: []),
							...(gt.structure === '3-glazed'
								? [
										{
											PRODUKT: {
												TYP: verasIds.middleGlassVerasType,
												NUMMER: verasIds.middleGlassVerasId,
												BEZEICHNUNG: '',
												INFOS: null,
											},
										},
										{
											PRODUKT: {
												TYP: 'ABSTANDHALTER',
												NUMMER: verasIds.spacerId,
												BEZEICHNUNG: '',
												INFOS: null,
											},
										},
										{
											PRODUKT: {
												TYP: 'GASFUELLUNGEN',
												NUMMER: verasIds.gasId,
												BEZEICHNUNG: '',
												INFOS: null,
											},
										},
									]
								: []),
							{
								PRODUKT: {
									TYP: verasIds.frgGlassVerasType,
									NUMMER: verasIds.frgGlassVerasId,
									BEZEICHNUNG: '',
									INFOS: null,
								},
							},
						]
					: [];

			out.push({
				NUMMER: out.length + 1,
				INFOS: {
					INFO: [
						{ TYP: 'KOMMISSION', WERT: conf.reference },
						{ TYP: 'ORIGINAL_POSITION', WERT: out.length + 1 },
						{ ...(p.notes ? { TYP: 'POSITIONSTEXT_KOPF', WERT: p.notes } : {}) },
					],
				},
				ANZAHL: p.quantity,
				PRODUKT: {
					TYP: verasIds.productType,
					NUMMER: verasIds.productId,
					BEZEICHNUNG: '',
					INFOS: null,
					VERPACKUNG: null,
				},
				DIMENSIONEN: {
					DIMENSION: [
						{ TYP: 'BREITE', WERT: verasFormatLen(p.length), EINHEIT: 'mm' },
						{ TYP: 'HOEHE', WERT: verasFormatLen(p.width), EINHEIT: 'mm' },
						{ TYP: 'GEWICHT', WERT: verasFormatLen(posTotal.kgPos), EINHEIT: 'kg' },
						{ TYP: 'FLAECHE', WERT: verasFormatLen(posTotal.m2Pc), EINHEIT: 'qm' },
						{ TYP: 'LFDM', WERT: verasFormatLen(posTotal.linearMeterPos), EINHEIT: 'm' },
					],
				},
				FORM:
					p.form === true
						? {
								KATALOG: 'A+W',
								NUMMER: 64,
								BEZEICHNUNG: '',
								DIMENSIONEN: {
									DIMENSION: [
										{ TYP: 'B', WERT: verasFormatLen(p.length), EINHEIT: 'mm' },
										{ TYP: 'H', WERT: verasFormatLen(p.width), EINHEIT: 'mm' },
									],
								},
							}
						: undefined,
				PREISE: {
					PREIS: {
						TYP: 'POSITION',
						WERT: verasFormatPrice(gt.sqmPrice * parseInt(p.quantity, 10)),
						WAEHRUNG: 'SFR',
						INFOS: null,
					},
				},
				...(gt.verasIds.productType === 'ISO'
					? {
							ELEMENTE: {
								SICHT: {
									TYP: 'BLICKRICHTUNG',
									WERT: 'AUSSEN',
								},
								ELEMENT: elements.map((e, elIdx) => ({
									NUMMER: elIdx + 1,
									...e,
								})),
							},
						}
					: {}),
				SPROSSEN: {
					INFOS: {
						INFO: [
							{
								TYP: 'Bezugspunkt',
								WERT: 'Sprossenmitte',
							},
							{
								TYP: 'Bezugsmaße',
								WERT: 'Außenkante Glas',
							},
						],
					},
				},
			});
		});
	});

	return out;
}

function buildTotals(conf, lang) {
	const { totalGlassSizesSum } = conf.totals;

	return {
		PREIS: [
			{
				TYP: 'NETTO',
				WERT: verasFormatPrice(totalGlassSizesSum.materialCosts),
				WAEHRUNG: 'SFR',
				INFOS: null,
			},
			{
				TYP: 'MWST',
				WERT: verasFormatPrice(totalGlassSizesSum.vatCosts),
				FAKTOR: verasFormatPrice(8.1), // TODO: configuratorData.pricing.vat_percent
				WAEHRUNG: 'SFR',
				INFOS: null,
			},
			{
				TYP: 'BRUTTO',
				WERT: verasFormatPrice(totalGlassSizesSum.total),
				WAEHRUNG: 'SFR',
				INFOS: null,
			},
			{
				TYP: 'ZUSCHLAG',
				WERT: verasFormatPrice(totalGlassSizesSum.shippingCosts),
				WAEHRUNG: 'SFR',
				INFOS: {
					INFO: {
						TYP: 'PREISINFO',
						WERT: ROAD_TAX[lang],
					},
				},
			},
		],
	};
}

function jsonConfigurationToVerasXmlObject(conf, lang = 'de') {
	return {
		DOKUMENTE: {
			KONVERTER: 'VERAS',

			HEADER: {
				ALLGEMEIN: {
					DATUM: conf.created,
					UHRZEIT: new Date(conf.publishedAt).toLocaleTimeString('de-CH', {
						hour: '2-digit',
						minute: '2-digit',
					}),
					BEARBEITER: '3D Konfigurator',
				},
				ADRESSEN: {
					ADRESSE: buildCdrAddress(),
				},
			},

			DOKUMENT: {
				'@_LFDNR': '1',
				'@_KundenNummer': '',
				'@_FirmenNummer': '',

				KOPF: {
					TYP: conf.type === CONFIGURATION_TYPE.order ? 'Bestellung' : 'Angebot',
					DATUM: conf.created,
					INFOS: {
						INFO: {
							TYP: 'BETREFF',
							WERT: conf.reference,
						},
					},
					BESTELLER: '',
					ADRESSEN: {
						ADRESSE: buildAddress(conf),
					},
					LIEFERUNG: {
						ART: freightMode(conf, lang),
					},
					ZAHLUNG: {
						ZAHLUNGSBEDINGUNG: PAYMENT_MODE[lang],
					},
					PREISE: buildTotals(conf, lang),
					STATI: null,
				},
				POSITIONEN: {
					POSITION: buildPositions(conf),
				},
				BILDER: null,
			},
		},
	};
}

function jsonConfigurationToVerasXml(exportedConfiguration, lang) {
	const xmlObject = jsonConfigurationToVerasXmlObject(exportedConfiguration, lang);
	const builder = new XMLBuilder({
		ignoreAttributes: false,
		format: true, // prettify for debug
	});
	const xmldec = '<?xml version="1.0" encoding="UTF-8"?>\n';
	return `${xmldec}${builder.build(xmlObject)}`;
}

export default jsonConfigurationToVerasXml;
